'use strict';
var $ = require('../internals/export');
var $entries = require('../internals/object-to-array').entries;

// `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries
$({ target: 'Object', stat: true }, {
  entries: function entries(O) {
    return $entries(O);
  }
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.object.entries.js
// module id = 480
// module chunks = 0